<template>
  <v-dialog
    v-model="userDeleteDialog"
    width="500"
    overlay-color="rgba(39, 50, 64)"
    overlay-opacity="0.6"
    :fullscreen="$vuetify.breakpoint.xs ? true : false"
    persistent
    :transition="false"
  >
    <v-card>
      <v-card-title
        class="header"
        primary-title
      >
        <b>{{ $t('users.deleteUser') }}</b>
      </v-card-title>
      <v-card-text>
        <b>{{ user.name }}</b><br>
        {{ user.email }}
        <v-divider class="mt-5 mb-5" />
        <b>{{ $t('users.deleteWarning') }} <br><br> 
          {{ $t('users.deleteUserAction') }}</b>
        <v-flex mt-5>
          <v-text-field
            v-model.trim="email"
            maxlength="50"
            :label="$t('globals.email')"
            @input="error = false"
          />
        </v-flex>
        <small
          v-if="error"
          color="error"
        >{{ $t('users.errorConfirmDeletion') }}</small>
      </v-card-text>
      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          :disabled="loading"
          @click="userDeleteDialog = false"
        >
          <span>{{ $t('globals.cancelButton') }}</span>
        </v-btn>
        <v-btn
          color="error"
          :disabled="loading"
          :loading="loading"
          @click="save()"
        >
          {{ $t('globals.deleteButton') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import USER_DELETE_MUTATION from "@/graphql/mutations/WhiteLabelDeleteUser.gql";

export default {
  name: "UserDeleteDialog",
  props: {
    user: {
      type: Object,
      default() {
        return null;
      }
    },
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      email: null,
      error: false
    };
  },
  computed: {
    userDeleteDialog: {
      get() {
        return this.showDialog;
      },
      set(val) {
        this.$emit('closeUserDeleteDialog', false);
      }
    }
  },
  methods: {
     save() {
      if (this.email != this.user.email) {
        this.error = true
        return
      }
      const params = {
        user_uuid: this.user.uuid
      }
      this.$apollo
        .mutate({
          mutation: USER_DELETE_MUTATION,
          variables: params
        })
        .then(data => {
          this.loading = false;
          this.$emit('closeUserDeleteDialog', true);
        })
        .catch(error => {
          this.errorHandler(error);
          this.loading = false;
        });
    }
  },
};
</script>

<style lang="scss" >
</style>
